export default "__VITE_ASSET__230fb182__"